<script>
export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <b-img :src="src" alt="alt"></b-img>
</template>

<style lang="scss" module>
@import '@design';
</style>
